<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="dealers">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="dealers"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="companyName" caption="Company" cellTemplate="dealerLinkTemplate"></dxi-column>
            <dxi-column dataField="portalEmail"></dxi-column>
            <dxi-column dataField="code" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="sent" format="shortDateShortTime" width="125"></dxi-column>
            <dxi-column dataField="submitted" format="shortDateShortTime" width="125"></dxi-column>
            <dxi-column dataField="validated" format="shortDateShortTime" width="125"></dxi-column>
            <dxi-column dataField="isSent" caption="IsSent" width="80"></dxi-column>
            <dxi-column dataField="isSubmitted" caption="IsSubmitted" width="80"></dxi-column>
            <dxi-column dataField="isValidated" caption="IsValidated" width="80"></dxi-column>
            <dxi-column width="80"></dxi-column>

            <div *dxTemplate="let cell of 'dealerLinkTemplate'">
                <a [routerLink]="['/dealers/overview/' + cell.data.id]">{{ cell.value ?? '' }}</a>
            </div>
            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="['/portal/dealer-entry/' + cell.value]">{{ cell.value ?? '' }}</a>
            </div>

            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
            <dxo-selection [mode]="'single'"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="dealer-entry-overview-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-sm btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])">Open</button>
                <button class="btn btn-sm btn-secondary ms-2" (click)="open()">New</button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Delete
                </button>
                <button
                    class="btn btn-sm btn-primary ms-2"
                    (click)="send(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || !dataGrid.instance.getSelectedRowsData()[0].portalEmail"
                >
                    Send
                </button>
                <button
                    class="btn btn-sm btn-secondary ms-2"
                    (click)="resetLink(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Reset Link
                </button>
            </div>
        </dx-data-grid>
    </div>
</div>
